import { createSlice } from '@reduxjs/toolkit';

interface ClaimedSliceState {
    data: any[],
    history: {
        totalPage: number,
        hasCurrentPage: boolean,
        hasPreviousPage: boolean,
        hasNextPage: boolean,
        currentPage: number,
        previousPage: number,
        list: any[]
    } | {}
}

const initialState: ClaimedSliceState = {
    data: [],
    history: {}
}

const claimedSlice = createSlice({
    name: "claimed",
    initialState,
    reducers: {
        setClaimedData: (state, action) => {
            return { ...state, data: action.payload };
        },
        setClaimedHistory: (state, action) => {
            return { ...state, history: { ...action.payload } };
        }
    }
});

export const { setClaimedData, setClaimedHistory } = claimedSlice.actions;
export const selectClaimedData = (state: { claimed: ClaimedSliceState }) => state.claimed.data;
export const selectClaimedHistory = (state: { claimed: ClaimedSliceState }) => state.claimed.history;
export default claimedSlice.reducer;